﻿'use strict';

angular.module('ntmApp').factory('StaffSchedulesFilter', ['HoursCompareFilter', 'SimpleFilter', 'WeeklyHoursFilter', 'Constants',
    function (HoursCompareFilter, SimpleFilter, WeeklyHoursFilter, Constants) {

    function StaffSchedulesFilter() {

        var self = this;

        self.AverageAvHoursFilter = new HoursCompareFilter('μ {0} {1} hours');
        self.StandartDeviationFilter = new HoursCompareFilter('σ {0} {1} hours');
        self.RoleFilter = new SimpleFilter(null, Constants.DropDownBlankLabels.NoRole);
        self.WeeklyAvailableHoursFilter = new WeeklyHoursFilter('Available {0} {1} hours');

        self.getFilters = function () {
            return [
                self.RoleFilter,
                self.WeeklyAvailableHoursFilter,
                self.AverageAvHoursFilter,
                self.StandartDeviationFilter
            ];
        };

        self.getAppliedFilters = function () {
            return self.getFilters().filter(function (filter) {
                return filter.isDefined();
            });
        };

        self.applied = function () {
            return self.AverageAvHoursFilter.isDefined() ||
                   self.StandartDeviationFilter.isDefined() ||
                   self.WeeklyAvailableHoursFilter.isDefined() ||
                   self.RoleFilter.isDefined();
        };

        self.isPartlyDefined = function () {
            return self.getFilters().some(function(filter) { return filter.isPartlyDefined(); });
        };

        self.clearAllFilters = function () {
            self.getFilters().forEach(function (filter) {
                filter.clear();
            });
        };

        self.isWeeklyAvailableHoursFilterApplied = function (blockHeader) {

            if (self.WeeklyAvailableHoursFilter.isDefined()) {

                var findDOWHoursGridByDayOfWeek = function (dow) {
                    var date = new moment(dow.date);
                    var dayOfWeek = date.day();
                    return dayOfWeek === selectedDay.dayOfWeek;
                };

                for (var i = 0; i < self.WeeklyAvailableHoursFilter.selectedDays.length; i++) {

                    var selectedDay = self.WeeklyAvailableHoursFilter.selectedDays[i];
                    var dowHours = blockHeader.availableHours.firstOrDefault(findDOWHoursGridByDayOfWeek);

                    if (dowHours) {

                        if (dowHours.present) {

                            var WeeklyAvailableHoursValidationResult = self.WeeklyAvailableHoursFilter.hoursComparator === '>=' ?
                                                                            dowHours.hours >= self.WeeklyAvailableHoursFilter.hours :
                                                                            dowHours.hours <= self.WeeklyAvailableHoursFilter.hours;

                            if (!WeeklyAvailableHoursValidationResult) {
                                return false;
                            }
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                }
            }

            return true;
        };

        self.isBlockHeaderApplied = function (blockHeader) {

            if (self.RoleFilter.isDefined() && (self.RoleFilter.filterItem.id !== blockHeader.role)) {
                return false;
            }

            if (self.AverageAvHoursFilter.isDefined()) {

                var AverageAvHoursValidationResult = self.AverageAvHoursFilter.hoursComparator === '>=' ?
                                                          blockHeader.averageAvailableHours >= self.AverageAvHoursFilter.hours :
                                                          blockHeader.averageAvailableHours <= self.AverageAvHoursFilter.hours;

                if (!AverageAvHoursValidationResult) {
                    return false;
                }
            }

            if (self.StandartDeviationFilter.isDefined()) {

                var StandartDeviationValidationResult = self.StandartDeviationFilter.hoursComparator === '>=' ?
                                                             blockHeader.standardDeviation >= self.StandartDeviationFilter.hours :
                                                             blockHeader.standardDeviation <= self.StandartDeviationFilter.hours;

                if (!StandartDeviationValidationResult) {
                    return false;
                }
            }

            return self.isWeeklyAvailableHoursFilterApplied(blockHeader);
        };
    }

    return (StaffSchedulesFilter);
}]);